<template>
	<div class="shop flex">
		<div style="flex-shrink: 0" class="mt-4">
			<img class="img" :src="row['productPicUrl']" alt="" />
		</div>
		<div class="ml-10 align-left shop-right yx-color-text-primary">
			<p class="flex flex-align-center">
				<platform-icon style="min-width: 15px" :platformId="row['platformId']"></platform-icon>
				<rd-text :showCopy="true" :useByTable="false" class="ml-4">{{ row['outerProductName'] | formatEmpty }}</rd-text>
			</p>

			<rd-text label="ID" :useByTable="false">{{ row['outerProductId'] }}</rd-text>
			<p class="yx-color-text-regular fz-12">
				<el-tooltip v-if="Object.keys(productTagInfo).length" :content="productTagInfo.tooltip" placement="top">
					<span class="product-tag mr-4" :class="productTagInfo.className">{{ row.productTypeName }}</span>
				</el-tooltip>
				<span class="team_pro mr-6" v-if="row['sourceType'] == 2">团长商品</span>
				<span class="brand-name pr-4 pl-4 pt-2 pb-2" v-if="row['brandName']">{{ row['brandName'] }}</span>
				<span class="ml-6 cate_name pr-4 pl-4 pt-2 pb-2" v-if="row['cateName']">{{ row['cateName'] }}</span>
			</p>
			<div class="fz-12 yx-color-text-secondary flex-row-align-center">
				<span style="min-width: 40px">店铺：</span>
				<rd-text color="#999999" :useByTable="false">{{ row.shopName | formatEmpty }}</rd-text>
				<ID-tag style="min-width: 20px" label="店铺ID" :id="row.shopId" />
			</div>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import { zsRoleType } from '@/utils/dataMap';
import IDTag from '@/components/ui/IDTag';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
	components: {
		IDTag,
	},
	computed: {
		productTagInfo() {
			const arr = [
				{ tooltip: `来源于团队“${zsRoleType.name}”角色，手动上传的商品`, className: 'one' },
				{ tooltip: '来源于商家，且未报名其他团长招商活动的商品', className: 'two' },
				{ tooltip: '来源于商家，且成功报名了其他团长招商活动的商品', className: 'three' },
				{ tooltip: '来源于其他团长的商品', className: 'four' },
				{ tooltip: '来源于商家，报名托管的商品', className: 'two' },
			];
			const { row: { productType = '' } = {} } = this;
			return arr[productType] || {};
		},
	},
	methods: {},
};
</script>
<style lang="less" scoped>
.img {
	width: 64px;
	height: 64px;
}
.third-id {
	white-space: nowrap;
}
.brand-name {
	color: #ae6c41;
	background-color: #fff2e9;
	border-radius: 2px;
	font-weight: 500;
}
.cate_name {
	background-color: #f8f8f8;
	color: #666666;
}
.team_pro {
	border-radius: 2px;
	padding: 2px 4px;
	text-align: center;
	width: 60px;
	background-color: #ebf2fd;
	color: @color-primary;
}
.product-tag {
	display: inline-block;
	height: 18px;
	line-height: 18px;
	padding: 0 4px;
	border-radius: 2px;
	font-size: 12px;
	&.one {
		color: #0c9f1b;
		background-color: #ecf4ed;
	}
	&.two {
		color: @color-primary;
		background-color: #ebf2fd;
	}
	&.three {
		color: #c87210;
		background-color: #fef3e7;
	}
	&.four {
		color: #333333;
		background-color: #f5f5f5;
	}
}
</style>
